import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import NewLocationPin from 'assets/svgs/iconPin.svg';
import NewProfileIcon from 'assets/svgs/profile.svg';
import ShipmentTruck from 'assets/svgs/shippingTruckBlue.svg';
import RequestShipping from 'assets/svgs/requestShipping.svg';
import { Link } from 'react-router-dom';
import PendingIcon from 'assets/svgs/pendingIcon.svg';

import './TcEventShipping.scss';

const TcEventShipping = ({
  tcEvent,
  openRequestUpdateTab,
  showPending,
  testCenterCycle
}) => {
  const { t } = useTranslation();
  const address2 = tcEvent.shipAddress3 ? `${tcEvent.shipAddress2},` : tcEvent.shipAddress2;
  return <div className="shipping-info">
    <div className="shipping-info-content">
      <div className="shipping-name address-item-container">
        <div className="icon-content"><NewProfileIcon/></div>
        <div className="fw-bold shipping-text">{tcEvent.shipName}</div>
      </div>
      <div className="address-item-container">
        <div className="icon-content">
          <NewLocationPin/>
        </div>
        <div className="shipping-text">
          {tcEvent.shipAddress1 && <div>
            <span className="pe-1">{tcEvent.shipAddress1}</span>
          </div>}
          <div>
            {tcEvent.shipAddress2 && <span className="pe-1">{address2}</span>}
            {tcEvent.shipAddress3 && <span className="pe-1">{tcEvent.shipAddress3}</span>}
          </div>
          <div>
            <div>
              {tcEvent.shipCity && <span className="pe-1">{tcEvent.shipCity},</span>}
              {tcEvent.shipStateCode && <span className="pe-1">{tcEvent.shipStateCode}</span>}
              {tcEvent.shipPostalCode && <span className="pe-1">{tcEvent.shipPostalCode}</span>}
            </div>
          </div>
        </div>
      </div>
      <div className="address-item-container">
        <div>
        </div>
        <div className="shipping-button-container">
          <button className="btn-link"
                  onClick={() => openRequestUpdateTab('shipping')}><RequestShipping/>{t('tcEventDashboard.shippingButtonLabel')}
          </button>
          <div>
            {showPending && <button
              className="btn btn-small request-update-edit-btn"
              onClick={() => openRequestUpdateTab('shipping')}
              data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover"
              data-bs-content={t('requestUpdate.pending.infoMessage')}
            >
              <PendingIcon />
              {t('requestUpdate.pending.editBtn')}
            </button>
            }
          </div>
        </div>
      </div>
      <div className="address-item-container">
        {!testCenterCycle.testCenterProgram.testCenter.nowManagedFlag &&
        <div className="shipping-button-container shipment-tracking">
          <Link className="btn-link" to={`/test-event/${tcEvent.id}/shipment-tracking`}
                href={`/test-event/${tcEvent.id}/shipment-tracking`}
          ><ShipmentTruck/>{t('tcEventDashboard.shipmentTracking')}
            </Link>

        </div>}
      </div>
    </div>
  </div>;
};

export default TcEventShipping;

TcEventShipping.propTypes = {
  tcEvent: PropTypes.shape({}).isRequired,
};
